import { CSSProperties } from 'react'

const HeadsetMic = ({ style, color = '#151515' }: { style?: CSSProperties; color?: string }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
            <path
                d="M15.8333 11.6666V15H14.1667V11.6666H15.8333ZM5.83333 11.6666V15H5C4.54167 15 4.16667 14.625 4.16667 14.1666V11.6666H5.83333ZM10 0.833313C5.85833 0.833313 2.5 4.19165 2.5 8.33331V14.1666C2.5 15.55 3.61667 16.6666 5 16.6666H7.5V9.99998H4.16667V8.33331C4.16667 5.10831 6.775 2.49998 10 2.49998C13.225 2.49998 15.8333 5.10831 15.8333 8.33331V9.99998H12.5V16.6666H15.8333V17.5H10V19.1666H15C16.3833 19.1666 17.5 18.05 17.5 16.6666V8.33331C17.5 4.19165 14.1417 0.833313 10 0.833313Z"
                fill={color}
            />
        </svg>
    )
}

export default HeadsetMic
